import RequestAuth from '../data/request-auth'

module.exports = class ApiSharedView {

    constructor() {

    }

    getData(publicKey) {
        return new RequestAuth(this, 'GET', 'shared-view/'+publicKey);
    }

    submitData(publicKey, action, data) {
        return new RequestAuth(this, 'POST', 'shared-view/'+publicKey,{
            action, data
        });
    }

    getSessionData(publicKey, dataToLoad) {
        return new RequestAuth(this, 'POST', 'shared-view/'+publicKey+'/session', dataToLoad);
    }


};
